import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {throttle, isFinite} from 'lodash';
import { componentIsInRangeOfViewport } from '../../utils/dom';

const EVENT_THROTTLE_MS = 50;

export default class Lazy extends Component {
  state = {
    visible: false
  };

  componentDidMount() {
    ['scroll', 'resize', 'touchend', 'wheel'].forEach(event => {
      window.addEventListener(event, this.handleViewportChange);
    });

    this.handleViewportChange();
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  removeEvents = () => {
    ['scroll', 'resize', 'touchend', 'wheel'].forEach(event => {
      window.removeEventListener(event, this.handleViewportChange);
    });
  };

  handleViewportChange = throttle(() => {
    const cushion = isFinite(this.props.cushion) // `isFinite` so we properly
      ? this.props.cushion // handle props.cushion === 0 😀
      : window.innerHeight * 2;

    if (componentIsInRangeOfViewport(this.placeholder, cushion, window)) {
      this.setState({ visible: true });
      this.removeEvents();
    }
  }, EVENT_THROTTLE_MS);

  setPlaceholderRef = (element) => {
    this.placeholder = element;
  };

  render() {
    const Wrapper = this.props.component || 'div';

    if (!this.state.visible) {
      return (
        <Wrapper
          className={this.props.className}
          ref={this.setPlaceholderRef}
        />
      );
    }

    return (
      <Wrapper className={this.props.className}>
        { this.props.children }
      </Wrapper>
    );
  }
}

Lazy.propTypes = {
  component: PropTypes.string,
  className: PropTypes.string,
  cushion: PropTypes.number,
  children: PropTypes.node.isRequired
};
